import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { nothing } from '$helper/functions/utils'
import { useAsyncFunction } from '$func/async-function.react-hook'
import {
  getAppNewReleases,
  needForceInstallTwa,
  needForceUpdateTwa,
} from '$logic/client-device/service'
import {
  clientSettingsView,
  saveReleaseVersion,
} from '$logic/client-device/storage'

import { FabButton, shouldShowFabButton } from './fab-buttons'
import { useClientUser } from '$logic/client-user'

export function useGetChangelog() {
  const { value: changeLog, loading } = useAsyncFunction(getAppNewReleases, [])
  const onClose = async () => {
    if (!changeLog?.[0]?.version) return
    await saveReleaseVersion(changeLog[0].date, changeLog[0].version)
  }
  return {
    loadMore: () => nothing,
    items: loading ? [] : changeLog,
    hasFinished: true,
    loading,
    onClose,
  }
}

export function useNeedForceUpdateTwa() {
  return useMemo(() => needForceUpdateTwa(), [])
}

export function useForceInstallTwaPageIsOpen() {
  const userId = useClientUser()?.id
  return useMemo(() => {
    if (userId) return needForceInstallTwa()
  }, [userId])
}

// CLIENT SETTINGS STORAGE HOOKS
export function useAutoPlayAudio() {
  return useSelector(state => clientSettingsView(state)?.autoPlayAudio) ?? true
}

export function useAutoDownload() {
  return useSelector(state => clientSettingsView(state)?.autoDownload) ?? false
}

export function useAutoSyncContactsIsEnabled() {
  return (
    useSelector(state => clientSettingsView(state)?.autoSyncContacts) ?? true
  )
}

export function useRecentUsersIsEnabled() {
  return useSelector(state => clientSettingsView(state)?.recentUsers) ?? true
}

export function useShouldShowFabButton(types: FabButton[]) {
  return useMemo(() => shouldShowFabButton(types), [types])
}
